import React from 'react';
import { TTemplate } from '@/helpers/createTemplate';
import { FeaturedMatch } from '../components/FeaturedMatch';
import {
  BoxHeadingWrapper,
  FlexWrapper,
  HeadingSlogan,
  SpanSlogan,
} from '../styles/Featured.styles';

const template: TTemplate = {
  wrapper: <FlexWrapper />,
  slogan: {
    wrapper: <BoxHeadingWrapper />,
    body: (
      <BoxHeadingWrapper>
        <HeadingSlogan>
          Seize
          <SpanSlogan>The Day</SpanSlogan>
        </HeadingSlogan>
      </BoxHeadingWrapper>
    ),
    feature: <FeaturedMatch />,
  },
};

export default template;
